import Constants from "../Constants";
export const cncBaseUrlSelector = () => {
  let baseUrl = process.env.REACT_APP_CNC_BASE_API_URL_QA;
  switch (localStorage.countryCode) {
    case "AE":
      baseUrl = process.env.REACT_APP_CNC_BASE_API_URL_AE;
      break;
    case "OM":
      baseUrl = process.env.REACT_APP_CNC_BASE_API_URL_OM;
      break;
    case "QA":
      baseUrl = process.env.REACT_APP_CNC_BASE_API_URL_QA;
      break;
    case "EG":
      baseUrl = process.env.REACT_APP_CNC_BASE_API_URL_EG;
      break;
    default:
      baseUrl = process.env.REACT_APP_CNC_BASE_API_URL_QA;
      break;
  }
  return baseUrl;
};

export const giftWalletBaseUrlSelector = () => {
  let baseUrl = process.env.REACT_APP_GIFT_WALLET_BASE_URL_QA;
  switch (localStorage.countryCode) {
    case "AE":
      baseUrl = process.env.REACT_APP_GIFT_WALLET_BASE_URL_AE;
      break;
    case "OM":
      baseUrl = process.env.REACT_APP_GIFT_WALLET_BASE_URL_OM;
      break;
    case "QA":
      baseUrl = process.env.REACT_APP_GIFT_WALLET_BASE_URL_QA;
      break;
    case "EG":
      baseUrl = process.env.REACT_APP_GIFT_WALLET_BASE_URL_EG;
      break;
    default:
      baseUrl = process.env.REACT_APP_GIFT_WALLET_BASE_URL_QA;
      break;
  }
  return baseUrl;
};

export const giftCardsBaseUrlSelector = () => {
  let baseUrl = process.env.REACT_APP_GIFT_CARDS_BASE_URL_QA;
  switch (localStorage.countryCode) {
    case "AE":
      baseUrl = process.env.REACT_APP_GIFT_CARDS_BASE_URL_AE;
      break;
    case "OM":
      baseUrl = process.env.REACT_APP_GIFT_CARDS_BASE_URL_OM;
      break;
    case "QA":
      baseUrl = process.env.REACT_APP_GIFT_CARDS_BASE_URL_QA;
      break;
    case "EG":
      baseUrl = process.env.REACT_APP_GIFT_CARDS_BASE_URL_EG;
      break;
    default:
      baseUrl = process.env.REACT_APP_GIFT_CARDS_BASE_URL_QA;
      break;
  }
  return baseUrl;
};

export const getCncAuthToken = () =>
  Constants[localStorage.countryCode]?.cncHttpAuthToken
    ? Constants[localStorage.countryCode]?.cncHttpAuthToken
    : Constants.QA.cncHttpAuthToken;

export const getGiftWalletAuthToken = () =>
  Constants[localStorage.countryCode]?.giftWalletHttpAuthToken
    ? Constants[localStorage.countryCode]?.giftWalletHttpAuthToken
    : Constants.QA.giftWalletHttpAuthToken;

export const trackOrderBaseUrlSelector = () => {
  let baseUrl = process.env.REACT_APP_TRACK_ORDER_BASE_URL_QA;
  switch (localStorage.countryCode) {
    case "AE":
      baseUrl = process.env.REACT_APP_TRACK_ORDER_BASE_URL_AE;
      break;
    case "OM":
      baseUrl = process.env.REACT_APP_TRACK_ORDER_BASE_URL_OM;
      break;
    case "QA":
      baseUrl = process.env.REACT_APP_TRACK_ORDER_BASE_URL_QA;
      break;
    case "EG":
      baseUrl = process.env.REACT_APP_TRACK_ORDER_BASE_URL_EG;
      break;
    default:
      baseUrl = process.env.REACT_APP_TRACK_ORDER_BASE_URL_QA;
      break;
  }
  return baseUrl;
};

export const getTrackOrderAuthToken = () =>
  Constants[localStorage.countryCode]?.trackOrderAuthToken
    ? Constants[localStorage.countryCode]?.trackOrderAuthToken
    : Constants.QA.trackOrderAuthToken;

export const getUIConfigBaseUrlSelector = () => {
  let baseUrl = process.env.REACT_APP_UI_CONFIG_BASE_URL_QA;
  switch (localStorage.countryCode) {
    case "AE":
      baseUrl = process.env.REACT_APP_UI_CONFIG_BASE_URL_AE;
      break;
    case "OM":
      baseUrl = process.env.REACT_APP_UI_CONFIG_BASE_URL_OM;
      break;
    case "QA":
      baseUrl = process.env.REACT_APP_UI_CONFIG_BASE_URL_QA;
      break;
    case "EG":
      baseUrl = process.env.REACT_APP_UI_CONFIG_BASE_URL_EG;
      break;
    default:
      baseUrl = process.env.REACT_APP_UI_CONFIG_BASE_URL_QA;
      break;
  }
  return baseUrl;
};


export const getMenuUIConfigBaseUrlSelector = () => {
  let baseUrl = process.env.REACT_APP_MENU_UI_CONFIG_BASE_URL_QA;
  switch (localStorage.countryCode) {
    case "AE":
      baseUrl = process.env.REACT_APP_MENU_UI_CONFIG_BASE_URL_AE;
      break;
    case "OM":
      baseUrl = process.env.REACT_APP_MENU_UI_CONFIG_BASE_URL_OM;
      break;
    case "QA":
      baseUrl = process.env.REACT_APP_MENU_UI_CONFIG_BASE_URL_QA;
      break;
    case "EG":
      baseUrl = process.env.REACT_APP_MENU_UI_CONFIG_BASE_URL_EG;
      break;
    default:
      baseUrl = process.env.REACT_APP_MENU_UI_CONFIG_BASE_URL_QA;
      break;
  }
  return baseUrl;
};


export const getUIConfigAuthToken = () =>
  Constants[localStorage.countryCode]?.uiConfigAuthToken
    ? Constants[localStorage.countryCode]?.uiConfigAuthToken
    : Constants.QA.uiConfigAuthToken;
